

















































import { defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

// 费用项配置
export interface FeeItemConfig {
  label: string | ((item: any) => string); // 支持动态标签
  field: string | string[]; // 支持多个字段（取第一个有值的）
  styleClass?: string;
}

export default defineComponent({
  props: {
    loanCalcList: {
      type: Array as PropType<any[]>,
      default: () => [],
      required: true,
    },
    /** 是否显示金额右侧附加信息 */
    showAmountExtra: {
      type: Boolean,
      default: true,
    },
    /** 费用项配置 */
    feeItems: {
      type: Array as PropType<FeeItemConfig[]>,
      default: () => [],
    },
    /** 是否按期还款 */
    repayOnSchedule: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: {
    loanCalcList: any[];
    showAmountExtra: boolean;
    feeItems: FeeItemConfig[];
    repayOnSchedule: boolean;
  }) {
    /** 格式化金额 */
    const formatAmount = (value: number | string) => {
      const num = Number(value);
      return num.toFixed(2);
    };

    /** 获取字段值 */
    const getFieldValue = (item: any, field: string | string[]) => {
      if (Array.isArray(field)) {
        // 取第一个有值的字段
        const value = field.find((f) => item[f]);
        return value ? item[value] : null;
      }
      return item[field];
    };

    /** 获取标签 */
    const getLabel = (config: FeeItemConfig, item: any) => (
      typeof config.label === 'function' ? config.label(item) : config.label
    );

    /** 获取费用项列表 */
    const getFeeItems = (item: any) => props.feeItems
      .map((config) => ({
        label: getLabel(config, item),
        value: getFieldValue(item, config.field),
        styleClass: config.styleClass,
      }))
      .filter((i) => i.value && Number(i.value) > 0);

    return {
      formatAmount,
      getFeeItems,
    };
  },
});
